
import Vue from 'vue';
import { OAuthProvider } from '../../utils/types.util';
import { ACTIONS } from '../../constants/actions';

export default Vue.extend({
  name: 'OAuthButton',
  props: {
    provider: {
      type: String as () => OAuthProvider,
      default: 'google'
    }
  },
  methods: {
    oAuthLogin(): void {
      const { dispatch } = this.$store;
      dispatch(ACTIONS.authentication.oAuthLoginRequest, this.provider);
    }
  }
});
